import axios from "./axios";

export type ThankYouMessageAlignment = "left" | "center";
export type ThankYouMessageBackground = "cream" | "navy";
// Animated memorial candle sold together with a message: 1 or 5 years.
export type ThankYouCandle = "1y" | "5y";

const getThankYouMessages = async () => {
  try {
    const response = await axios.get("/thank-you");
    return response.data;
  } catch (error: any) {
    console.error("Error fetching thank-you messages:", error);
    return { error: error?.response?.data?.message || error?.message };
  }
};

// Saves the message and returns the Stripe Checkout URL the customer must pay at.
const createThankYouMessage = async (payload: {
  obituaryId: number;
  headline: string;
  message: string;
  authorName: string;
  alignment: ThankYouMessageAlignment;
  background: ThankYouMessageBackground;
  // What the author changed on the card in step 2; "" means "show nothing".
  cardDates?: string;
  cardLocation?: string;
  cardImage?: string;
  cardSymbol?: string;
  candle?: ThankYouCandle;
  // "Zahvala" and "Spomin" are the same form but separate Stripe products.
  kind?: "zahvala" | "spomin";
}) => {
  const response = await axios.post("/thank-you", payload);
  return response.data as { messageId: number; paymentUrl: string };
};

// Uploads the photo chosen in step 2 and returns its CDN address.
const uploadThankYouCardImage = async (file: File) => {
  const form = new FormData();
  form.append("image", file);
  const response = await axios.post("/thank-you/card-image", form);
  return response.data as { url: string };
};

// Called when the customer returns from Stripe; the server verifies the payment before publishing.
const confirmThankYouMessage = async (messageId: string, sessionId: string) => {
  const response = await axios.get("/thank-you/confirm", {
    params: { messageId, session_id: sessionId },
  });
  return response.data as { published: boolean };
};

const thankYouService = {
  getThankYouMessages,
  createThankYouMessage,
  uploadThankYouCardImage,
  confirmThankYouMessage,
};

export default thankYouService;
